import { withNamespaces } from 'react-i18next';
import { Button } from 'reactstrap';

const MailboxBackButton = ({
    t,
    folderTitleKey,
    className = '',
    onClick,
}) => (
    <Button
        type="button"
        color="link"
        className={`mailbox-back-button px-0 ${className}`.trim()}
        title={folderTitleKey ? t(folderTitleKey) : t('Back')}
        onClick={onClick}
    >
        <i className="ri-arrow-left-s-line" />
        {t('Back')}
    </Button>
);

export default withNamespaces()(MailboxBackButton);
